/** @module Enums */ /** typedoc */

export enum ExternalTypeEnum {
    SoundCloud = 'SoundCloud',
    Facebook = 'Facebook',
    ASCAP = 'ASCAP'
}
